import { useEffect, useState } from 'react';
import { fetchDoctorCount, fetchPatientCount, fetchAppointmentCount, fetchDoctorsPerMonth, fetchPatientsPerMonth, fetchAppointmentsPerMonth } from '../../services/api';
// import { FaUserMd, FaUser, FaCalendarAlt, FaChartBar } from 'react-icons/fa'; // Avoid icons
import { useNavigate } from 'react-router-dom';

function KPIBox({ label, value, onClick }) {
    return (
        <div onClick={onClick} style={{
            background: '#fff', borderRadius: 16, boxShadow: '0 2px 8px #e0e0e0', padding: 24, minWidth: 180, minHeight: 120,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: onClick ? 'pointer' : 'default', transition: 'box-shadow 0.2s',
            margin: 8
        }}>
            <div style={{ fontSize: 32, fontWeight: 800, color: '#2e7d32' }}>{value}</div>
            <div style={{ fontSize: 16, color: '#888', marginTop: 4 }}>{label}</div>
        </div>
    );
}

function Histogram({ title, data = [], color }) {
    const safeData = Array.isArray(data) ? data : [];
    const values = safeData.map(d => (typeof d.value === 'number' && !isNaN(d.value) ? d.value : 0));
    const filtered = values.filter(v => v > 0);
    const max = filtered.length > 0 ? Math.max(...filtered) : 1;
    return (
        <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 2px 8px #e0e0e0', padding: 24, margin: 16, flex: 1, minWidth: 220 }}>
            <div style={{ fontWeight: 700, color: '#388e3c', marginBottom: 12 }}>{title}</div>
            <div style={{ display: 'flex', alignItems: 'flex-end', height: 140, gap: 12, width: '100%' }}>
                {safeData.map((d, i) => {
                    const value = typeof d.value === 'number' && !isNaN(d.value) ? d.value : 0;
                    const percent = max > 0 ? Math.round((value / max) * 100) : 100;
                    return (
                        <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 0 }}>
                            <div style={{
                                height: `${percent}%`,
                                minHeight: 12,
                                width: 28,
                                background: color,
                                borderRadius: 6,
                                marginBottom: 4,
                                display: 'flex',
                                alignItems: 'flex-end',
                                justifyContent: 'center',
                                position: 'relative',
                            }}>
                                <span style={{
                                    position: 'absolute',
                                    top: -22,
                                    fontSize: 13,
                                    color: '#222',
                                    fontWeight: 700,
                                    background: '#fff',
                                    borderRadius: 6,
                                    padding: '2px 6px',
                                    boxShadow: '0 1px 4px #e0e0e0',
                                }}>{value}</span>
                            </div>
                            <div style={{ fontSize: 12, color: '#888', marginTop: 2, textAlign: 'center' }}>{d.label}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default function AdminDashboard() {
    const navigate = useNavigate();
    const [stats, setStats] = useState({
        numDoctors: 0,
        numPatients: 0,
        numAppointments: 0,
        doctorsPerMonth: [],
        patientsPerMonth: [],
        appointmentsPerMonth: []
    });

    useEffect(() => {
        async function fetchCounts() {
            try {
                const [numDoctors, numPatients, numAppointments, doctorsPerMonth, patientsPerMonth, appointmentsPerMonth] = await Promise.all([
                    fetchDoctorCount(),
                    fetchPatientCount(),
                    fetchAppointmentCount(),
                    fetchDoctorsPerMonth(),
                    fetchPatientsPerMonth(),
                    fetchAppointmentsPerMonth()
                ]);
                setStats({
                    numDoctors,
                    numPatients,
                    numAppointments,
                    doctorsPerMonth,
                    patientsPerMonth,
                    appointmentsPerMonth
                });
            } catch (err) {
                console.error("Failed to fetch admin stats", err);
            }
        }
        fetchCounts();
    }, []);

    return (
        <div style={{ padding: 40, marginTop: 64 }}>
            <h2 style={{ color: '#2e7d32', marginBottom: 32 }}>Admin Dashboard</h2>

            <div style={{ marginBottom: 32, display: 'flex', gap: 16 }}>
                <button onClick={() => navigate('/admin/users')} style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 24px', fontSize: 16, cursor: 'pointer', fontWeight: 600 }}>Manage Users</button>
                <button onClick={() => navigate('/admin/affectations')} style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 24px', fontSize: 16, cursor: 'pointer', fontWeight: 600 }}>Manage Affectations</button>
                <button onClick={() => navigate('/admin/consultations')} style={{ background: '#2e7d32', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 24px', fontSize: 16, cursor: 'pointer', fontWeight: 600 }}>Manage Requests</button>
            </div>

            <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap', marginBottom: 32 }}>
                <KPIBox label="Médecins" value={stats.numDoctors} onClick={() => navigate('/admin/users')} />
                <KPIBox label="Patients" value={stats.numPatients} onClick={() => navigate('/admin/users')} />
                <KPIBox label="Rendez-vous" value={stats.numAppointments} />
            </div>

            <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
                <Histogram title="Médecins inscrits par mois" data={stats.doctorsPerMonth} color="#388e3c" />
                <Histogram title="Patients inscrits par mois" data={stats.patientsPerMonth} color="#1976d2" />
                <Histogram title="Rendez-vous par mois" data={stats.appointmentsPerMonth} color="#ff9800" />
            </div>
        </div>
    );
}
